import {
  ListItemButton, ListItemIcon, ListItemText, Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { style } from '../style';

export const NavItem = ({
  hash,
  icon,
  title,
  counter,
  isError,
}: NavItemProps): JSX.Element => {
  return (
    <a href={ hash }>
      <ListItemButton sx={ style.boxSvg.sx }>
        <ListItemIcon>
          { icon }
        </ListItemIcon>
        <Box sx={ style.boxListContainer.sx }>
          <ListItemText sx={ isError ?
            style.listItemTextStyle.errorStyle :
            style.listItemTextStyle.defaultStyle }
          >
            { title }
          </ListItemText>
          <Typography
            sx={ isError ?
              style.menuList.typography.sxError :
              style.menuList.typography.sxDefault }
          >
            { counter }
          </Typography>
        </Box>
      </ListItemButton>
    </a>
  );
};
